import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import QRCode from "qrcode";

function remainingLabel(expiresAt) {
  if (!expiresAt) return "";
  const ms = new Date(expiresAt).getTime() - Date.now();
  if (ms <= 0) return "0:00";
  const total = Math.floor(ms / 1000);
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

function stop(event) {
  if (!event) return;
  event.preventDefault();
  event.stopPropagation();
}

function OperatorAccessModal({ pending, operatorName, onClose }) {
  const { t } = useTranslation();
  const [qrUrl, setQrUrl] = useState("");
  const [clock, setClock] = useState(() =>
    remainingLabel(pending && pending.expiresAt)
  );

  useEffect(() => {
    if (!pending || !pending.code) return undefined;
    let cancelled = false;
    QRCode.toDataURL(String(pending.code), { width: 220, margin: 1 }).then(
      (url) => {
        if (!cancelled) setQrUrl(url);
      }
    );
    const timer = setInterval(() => {
      setClock(remainingLabel(pending.expiresAt));
    }, 1000);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [pending]);

  if (!pending || typeof document === "undefined" || !document.body) {
    return null;
  }

  const expired = clock === "0:00";

  return createPortal(
    <div
      className="operator-access-modal"
      onMouseDown={stop}
      onClick={(event) => {
        stop(event);
        onClose(event);
      }}
    >
      <div
        className="operator-access-modal__card"
        onMouseDown={stop}
        onClick={stop}
      >
        <h3>{t("Código de acesso do app")}</h3>
        <p>
          {t(
            "Peça ao operador {{name}} para digitar ou escanear este código no tablet.",
            {
              name: operatorName,
            }
          )}
        </p>
        <div className="operator-access-modal__code">{pending.code}</div>
        <p className={expired ? "operator-access-modal__expired" : ""}>
          {expired
            ? t("Código expirado. O app pode pedir um novo.")
            : `${t("Expira em")} ${clock}`}
        </p>
        {qrUrl ? (
          <img
            src={qrUrl}
            alt={t("QR Code de acesso")}
            width={180}
            height={180}
          />
        ) : null}
        <button
          type="button"
          className="btn btn-default"
          onMouseDown={stop}
          onClick={(event) => {
            stop(event);
            onClose(event);
          }}
        >
          {t("Fechar")}
        </button>
      </div>
    </div>,
    document.body
  );
}

export default OperatorAccessModal;
